<template>
    <b-container fluid class="bv-example-row">
        <b-row class="justify-content-center">
            <b-card class="mt-9" bg-variant="light">
                <b-card-body class="px-lg-5 py-lg-1">
                    {{ /* Display success message on submit */}}
                    <template v-if="submitted">
                        <b-card-text class="
                                display-4
                                font-weight-bold
                                mb-4
                                mt-4
                                text-center
                            ">
                            Password Recovery
                        </b-card-text>
                        <b-card-text class="text-center text-muted mb-4 mt-4">
                            We have sent a recovery email to you. Please
                            continue the password recovery process there.
                        </b-card-text>
                        <b-row class="justify-content-center">
                            <b-button variant="primary" @click="backToLogin()">Back To Login</b-button>
                        </b-row>
                    </template>

                    <template v-else>
                        <b-card-text class="text-center text-muted mb-4 mt-4">
                            <h5 class="display-4 font-weight-bold">
                                Forgot Your Password?
                            </h5>
                        </b-card-text>
                        <b-card-text class="justify-content-center text-muted mb-4">
                            <small>Enter your email address and we'll email you
                                instructions on how to reset your
                                password</small>
                        </b-card-text>

                        <b-alert variant="danger" :show="signInError">Email Invalid</b-alert>
                        <b-form role="form" submit.prevent="submit">
                            <b-input-group>
                                <b-input-group-prepend>
                                    <b-input-group-text>
                                        <b-icon icon="envelope-fill"></b-icon>
                                    </b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input placeholder="Email" v-model="model.email" type="email" class="pl-2"
                                    name="email" :error="errors.first('email')" v-validate="'required|email'">
                                </b-form-input>
                            </b-input-group>
                            <div class="text-right mt-4 mb-4">
                                <b-button-group>
                                    <b-button variant="warning" @click="backToLogin()">Go Back</b-button>
                                    <b-button variant="primary" :disabled="submitting ? true : false" @click="submit()">
                                        {{
        submitting
            ? 'Submitting...'
            : 'Recover Your Password'
                                        }}</b-button>
                                </b-button-group>
                            </div>
                        </b-form>
                    </template>
                </b-card-body>
            </b-card>
        </b-row>
    </b-container>
</template>
<script>
import api from '@/api/auth'
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'login',
    data() {
        return {
            submitting: false,
            signInError: false,
            submitted: true,
            model: {
                email: '',
            },
        }
    },
    mixins: [popupMixins],
    mounted() {
        this.submitted = false
        this.signInError = false
        this.submitting = false
    },
    methods: {
        async submit() {
            try {
                const valid = await this.$validator.validate();
                if (!valid) {
                    throw new Error("Invalid")
                }
                this.submitting = true
                console.log('forgot submit--------')
                const resp = await api.requestPasswordReset(this.model.email)

                console.log('forgot resp', resp)
                this.submitted = true
            }
            catch (error) {
                // show error
                console.error("forgot submit:--", error)
                this.signInError = true
            }
            finally {
                this.signingIn = false
                this.submitting = false
            }
        },
        backToLogin() {
            this.$router.push('/login')
        },
    },
}
</script>
<style>

</style>
